import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const CaravanLocation = ({ caravanLocation }: SpecProps<"caravan_location">) => {
  const { i18n } = useLingui();

  if (!caravanLocation) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.caravanLocation",
    message: "The caravan is in",
    comment: "Field for 'caravan location' in ad specification",
  });
  return <FieldValuePair field={field} value={caravanLocation} />;
};
